import * as React from 'react';

interface H1orH2Props {
  sliceIndex: number;
  [key: string]: any;
}

/** Determines h tag number based on slice index */
const H1orH2: React.FunctionComponent<H1orH2Props> = ({
  sliceIndex,
  children,
  ...delegated
}) => {
  return sliceIndex === 0 ? (
    <h1 {...delegated}>{children}</h1>
  ) : (
    <h2 {...delegated}>{children}</h2>
  );
};

export default H1orH2;
